export const PRINT_HOST =
  process.env.NEXT_PUBLIC_ENV_MODE === "local"
    ? "http://localhost:5173"
    : "https://print.agendalink.app";

export const ENV_MODE = process.env.NEXT_PUBLIC_ENV_MODE;
